import React from 'react'
import WebApiSvg from '../svgs/WebApiSvg'
import AutomateSvg from '../svgs/AutomateSvg'
import { Link } from 'react-router-dom'


const AboutMeRightContent = () => {
    return (
        <div>
            <span style={{ color: "#d29345" }}>
                <h7 style={{ color: "#d29345", fontWeight: "bold" }}>About Me</h7>
            </span>
            <hr style={{ position: "relative", top: "-5px", marginBottom: "6px" }} />
            <span style={{ fontSize: "12.5px", textAlign: "justify" }}>
                Hello! I'm Yash Marmat. I graduated with a degree in Computer Science and Engineering from Maharshi Dayanand University in 2020. Following my graduation, I have actively engaged in various <Link to="/projects" style={{ textDecoration: "none"}}>projects</Link>, employing the latest technology stack.
            </span>

            <div className='mt-3'>
            <h7 className='mt-3' style={{ color: "#d29345", fontWeight: "bold" }}>Key Details</h7>
            </div>
            <hr style={{ position: "relative", top: "-5px", marginBottom: "6px" }} />
            {/* More Info (in Tabular) */}
            <table className="table table-borderless table-dark" style={{ backgroundColor: "#313139", color: "#fff", fontSize: "12.5px" }}>
                <tbody>
                    <tr>
                        <td><li>Qualification: <span style={{ color: "#807f87" }}>B.Tech</span></li></td>
                        <td><li>Speciality: <span style={{ color: "#807f87" }}>CSE</span></li></td>
                        <td><li>University: <span style={{ color: "#807f87" }}>MDU (Rohtak)</span></li></td>
                    </tr>

                    <tr>
                        <td><li>Year: <span style={{ color: "#807f87" }}>2016 - 2020</span></li></td>
                        <td><li>Experience: <span style={{ color: "#807f87" }}>2+ Years</span></li></td>
                        <td><li>Location: <span style={{ color: "#807f87" }}>New Delhi, INDIA</span></li></td>
                    </tr>

                    <tr>
                        <td><li>Contact: <span style={{ color: "#807f87" }}>9650266386</span></li></td>
                        <td><li>Email: <span style={{ color: "#807f87" }}>yashmarmat08@gmail.com</span></li></td>
                        <td><li>Availability: <span style={{ color: "#807f87" }}>Open to Work</span></li></td>
                    </tr>
                </tbody>
            </table>

            <h7 style={{ color: "#d29345", fontWeight: "bold" }}>Work Speciality</h7>
            <hr style={{ position: "relative", top: "-5px", marginBottom: "6px" }} />
            <div style={{ display: "flex", gap: "20px" }}>
                <div className='card w-100 p-2' style={{ backgroundColor: "#313139", color: "white", border: "none" }}>
                    <p><WebApiSvg /> <b>Web/API Development</b></p>
                    <p style={{ fontSize: "12.5px", textAlign: "justify" }}>{"Crafting Digital Experiences: Proficient in Django Backend, Templates, and API Development with Django Rest Framework (DRF) and Flask. Well-versed in HTML, CSS, and React for a comprehensive approach to web development."}</p>
                </div>
                <div className='card w-100 p-2' style={{ backgroundColor: "#313139", color: "white", border: "none" }}>
                    <p><AutomateSvg /> <b>Automation</b></p>
                    <p style={{ fontSize: "12.5px", textAlign: "justify" }}>{"Empowering Automation and Efficiency: Python enthusiast skilled in automation, web scraping, and Docker for scalability. Consumed AWS services like S3, EC2, Lambda etc. for seamless integration and enhanced functionality."}</p>
                </div>
            </div>
        </div>
    )
}

export default AboutMeRightContent